module.exports = __webpack_public_path__ + "static/media/FilterIcon.d506b6cc.svg";